import { ConstructorAnalytics } from '~/src/features/tariffBuilder/analytics';
import { EAction } from '~/src/features/tariffBuilder/constants/actions';
import { EEntity } from '~/src/features/tariffBuilder/types/EEntity';
import { IAction } from '~/src/store';

type TAddEntityArgs = {
    entity: Exclude<EEntity, EEntity.speed | EEntity.tv | EEntity.services | EEntity.entertainments>,
    key: number,
    quantity?: number,
    period?: number,
    cost?: number,
    title?: string,
}

const addEntity = (entityData: TAddEntityArgs, analytics: ConstructorAnalytics): IAction<EAction.AddEntity, TAddEntityArgs> => {
    const { entity, key, quantity = 1, period = 1, title = '', cost } = entityData;

    if (title) {
        switch (entity) {
            case EEntity.decoders:
                analytics.addProductSuccess({ type: 'decoder', title, cost, period });
                break;
            case EEntity.routers:
                analytics.addProductSuccess({ type: 'router', title, cost, period });
                break;
            case EEntity.onlineCinemas:
                analytics.clickedOnlineCinemaCheckBox(title);
                break;
            case EEntity.additional:
                analytics.clickedSubscriptionCheckBox(title);
                break;
            case EEntity.antivirus:
                analytics.clickedAntivirusCheckBox(title);
                break;
        }
    }

    return ({
        type: EAction.AddEntity,
        payload: {
            entity,
            key,
            quantity,
            period,
        },
    });
};

export default addEntity;
